import React from 'react';

import CommonModal from '../../../../components/common-modal/CommonModal';
import StoryMediaView from '../story-media-view/StoryMediaView';

import scss from './MediaPreviewModal.module.scss';

function MediaPreviewModal({ isOpen, onClose, media }) {
  return (
    <CommonModal isOpen={Boolean(isOpen)} onClose={onClose} isAnimated>
      {media ? (
        <div className={scss.wrapper}>
          <StoryMediaView media={media} variant='preview' className={scss.image} videoClassName={scss.video} />
        </div>
      ) : null}
    </CommonModal>
  );
}

export default MediaPreviewModal;
